/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/frame_ship_hidden': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 32.076L2 24.037V7.965L16-.076l14 8.041v16.072l-14 8.039zM3 23.459l13 7.465 13-7.465V8.543L16 1.076 3 8.543v14.916z"/><path pid="1" d="M21 8h2v1h-2zM23 9h1v2h-1zM21 10h1v1h-1zM20 11V8h-3v1h2v2h-1v-1h-1v2h2v1h2v-2zM21 13h1v1h-1zM23 14h-1v1h2v-3h-1zM23 18h1v5h-1zM22 21v-3h-2v1h1v2h-2v-1h1v-1h-1v-1h-1v4h4zM21 23h2v1h-2zM18 22h-1v2h3v-1h-2zM9 23h2v1H9zM8 21h1v2H8zM9 8h2v1H9zM8 9h1v5H8zM9 17H8v3h1v-2h1v-1zM10 21h1v1h-1zM10 18h1v1h-1zM10 11v3h2v-1h-1v-2h2v1h-1v1h1v1h1v-4h-4zM14 10h1V8h-3v1h2zM16 13h2v1h-2zM14 18h2v1h-2zM15 17v-1h1v-1h-2v1h-1v-1h-2v2h2v1h1v-1zM17 17h1v-1h1v1h2v-2h-2v-1h-1v1h-1v1h-1v1zM15 11h1v2h-1zM16 19h1v2h-1zM16 9h1v1h-1zM13 21h1v1h1v-2h-2v-1h-2v2h1v3h3v-1h-2zM15 22h1v1h-1z"/>'
  }
})
